// Admin-only manager intake-duty hooks (#1261). GET /lead-intake-duty
// lists eligible managers + anyOnDuty; PATCH /lead-intake-duty/:userId
// toggles a single manager's onDuty.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  ListManagerDutyResponseSchema,
  ManagerDutyItemSchema,
  type ListManagerDutyResponse,
  type ManagerDutyItem,
  type ToggleManagerDutyInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export interface UseManagerDutyListOptions {
  /** Park the query for non-admin consumers so they never fire a 403. */
  enabled?: boolean;
}

export function useManagerDutyList(options: UseManagerDutyListOptions = {}) {
  const client = useApiClient();
  const enabled = options.enabled ?? true;
  return useQuery<ListManagerDutyResponse>({
    queryKey: ['lead-intake-duty', 'list'],
    queryFn: ({ signal }) =>
      client.get<ListManagerDutyResponse>(
        '/lead-intake-duty',
        { signal },
        ListManagerDutyResponseSchema,
      ),
    enabled,
  });
}

export function useToggleManagerDuty(userId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ManagerDutyItem, unknown, ToggleManagerDutyInput>({
    mutationFn: (input) =>
      client.patch<ManagerDutyItem>(
        `/lead-intake-duty/${userId}`,
        input,
        {},
        ManagerDutyItemSchema,
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['lead-intake-duty', 'list'] }),
  });
}
